export type HistoryReport = {
  id: string;
  name: string;
  date: Date;
};

export function openHistoryReport(reportId: string, reportName: string) {
  const reports = historyReports();
  reports.push({ id: reportId, name: reportName, date: new Date() });
  localStorage.setItem("HISTORY REPORTS", JSON.stringify(reports));
}

export function historyReports(): HistoryReport[] {
  const store = localStorage.getItem("HISTORY REPORTS");
  const reports: HistoryReport[] = store ? JSON.parse(store) : [];
  return reports;
}

export function clearHistoryReports() {
  localStorage.removeItem("HISTORY REPORTS");
}
